module.exports = __webpack_public_path__ + "media/images/drop-icon-inactive-3f92ecc5b09dc75df8a68c56f90b18f081cbdbf107eb9861f56a5848ea120f11.svg";